'use client'

import { useEffect } from "react"
import { useTranslation } from "react-i18next"
import { toast } from "sonner"

export const AuthToastMessage = ({ ref }: { ref: string | null }) => {
  const { t } = useTranslation()
  const knownKeys = ['verified', 'verify_already_verified', 'verify_token_invalid', 'verify_not_found']

  useEffect(() => {
    if (!ref || !knownKeys.includes(ref)) {
      return
    }

    toast.info(t(`auth.ref.${ref}`), {
      duration: 5000,
      dismissible: true,
      closeButton: true,
      id: ref,
    })
  }, [ref])

  return null
}
